import type { ICMSResponse, IScripts } from "./../../type"

export default defineNuxtPlugin(async (ctx) => {
  if (import.meta.client) {
    try {
      const res = await $fetch<ICMSResponse<IScripts>>('/api/cms/v1/scripts', {
        headers: {
          'Content-Type': 'application/json'
        },
        query: {
          domain: window.document.location.host,
          position: 'body'
        }
      })

      for (const html of res.docs) {
        const template = document.createElement('template')
        template.innerHTML = html.content.trim()

        const node = template.content.firstElementChild as HTMLScriptElement | null
        if (!node) continue

        // IMPORTANT: re-create script to force execution
        const script = document.createElement('script')

        // copy attributes (src, async, etc.)
        for (const attr of node.attributes) {
          script.setAttribute(attr.name, attr.value)
        }

        // inline script content
        script.textContent = node.textContent || ''

        document.body.appendChild(script)
      }
    } catch (e) {

    }
  }
})
